import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=d4d23226&scoped=true&"
import script from "./ForgotPassword.vue?vue&type=script&lang=js&"
export * from "./ForgotPassword.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/frontend/content.scss?vue&type=style&index=0&id=d4d23226&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4d23226",
  null
  
)

export default component.exports